export const LeafletIcons = {
  blue: new L.Icon({
    iconUrl: require('./assets/marker-icon-2x-blue.png'),
    shadowUrl: require('./assets/marker-shadow.png'),
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  }),

  gold: new L.Icon({
    iconUrl: require('./assets/marker-icon-2x-gold.png'),
    shadowUrl: require('./assets/marker-shadow.png'),
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  }),

  red: new L.Icon({
    iconUrl: require('./assets/marker-icon-2x-red.png'),
    shadowUrl: require('./assets/marker-shadow.png'),
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  }),

  green: new L.Icon({
    iconUrl: require('./assets/marker-icon-2x-green.png'),
    shadowUrl: require('./assets/marker-shadow.png'),
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  }),

  // orange: new L.Icon({
  //  iconUrl: require('./assets/marker-icon-2x-orange.png'),
  //  shadowUrl: require('./assets/marker-shadow.png'),
  //  iconSize: [25, 41],
  //  iconAnchor: [12, 41],
  //  popupAnchor: [1, -34],
  //  shadowSize: [41, 41]
  // }),
  //
  // yellow: new L.Icon({
  //  iconUrl: require('./assets/marker-icon-2x-yellow.png'),
  //  shadowUrl: require('./assets/marker-shadow.png'),
  //  iconSize: [25, 41],
  //  iconAnchor: [12, 41],
  //  popupAnchor: [1, -34],
  //  shadowSize: [41, 41]
  // }),

  violet: new L.Icon({
    iconUrl: require('./assets/marker-icon-2x-violet.png'),
    shadowUrl: require('./assets/marker-shadow.png'),
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  }),

  waves: new L.Icon({
    iconUrl: require('./assets/marker-icon-2x-blue-waves.png'),
    shadowUrl: require('./assets/marker-shadow.png'),
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  }),

  // grey: new L.Icon({
  //  iconUrl: require('./assets/marker-icon-2x-grey.png'),
  //  shadowUrl: require('./assets/marker-shadow.png'),
  //  iconSize: [25, 41],
  //  iconAnchor: [12, 41],
  //  popupAnchor: [1, -34],
  //  shadowSize: [41, 41]
  // }),
  //
  // black: new L.Icon({
  //  iconUrl: require('./assets/marker-icon-2x-black.png'),
  //  shadowUrl: require('./assets/marker-shadow.png'),
  //  iconSize: [25, 41],
  //  iconAnchor: [12, 41],
  //  popupAnchor: [1, -34],
  //  shadowSize: [41, 41]
  // })
}

export const Icons = {
  all: {
    gold: {
      image: require('./assets/marker-icon-gold.png'),
    },

    red: {
      image: require('./assets/marker-icon-red.png'),
    },

    green: {
      image: require('./assets/marker-icon-green.png'),
    },

    // orange: {
    //  image: require('./assets/marker-icon-orange.png'),
    // },
    //
    // yellow: {
    //  image: require('./assets/marker-icon-yellow.png'),
    // },

    violet: {
      image: require('./assets/marker-icon-violet.png'),
    },

    // grey: {
    //  image: require('./assets/marker-icon-grey.png'),
    // },
    //
    // black: {
    //  image: require('./assets/marker-icon-black.png'),
    // }
  },
  blue: {
    image: require('./assets/marker-icon-blue.png'),
  },
  waves: {
    image: require('./assets/marker-icon-blue-waves.png'),
  }

}
